<template>
    <div class="page_czj flex-col">
        <div class="block_54 flex-col">

            <div class="group_70 flex-col">
                <div class="text-group_231 flex-col justify-between">
                    <span class="text_199">行业价值</span>
                    <span class="text_200">INDUSTRY&nbsp;VALUE</span>
                </div>
                <div class="group_108 flex-row justify-between">
                    <div class="group_109 flex-col">
                        <div
                                v-for="(item, index) in items"
                                :key="index"
                                class="flex-row"
                                :class="activeIndex === index ? (index === 0 ? 'section_33_hover_first' : 'section_33_hover')
      : 'section_33'"
                                @click="handleSelectIndex(index)"
                                @mouseover="hoverIndexFun(index) "
                                @mouseleave="offhoverIndexFun"
                        >
                            <img class="label_11" :src="item.icon" />
                            <span :class="['text', activeIndex === index ? 'text_201' : 'text_202']">
                {{ item.text }}
              </span>
                        </div>
                    </div>
                    <div class="group_73 flex-col">
                        <img
                                class="image_37"
                                referrerpolicy="no-referrer"
                                src="../../../assets/home/chpc_about_industry_01.png"
                        />
                        <div class="image-text_195 flex-row justify-between">
                            <img
                                    class="thumbnail_9"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/home/chpc_about_industry_02.png"
                            />
                            <transition name="fade" mode="out-in">
                <span class="text-group_147" :key="activeIndex">
                  {{ items[activeIndex].content }}
                </span>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectedIndex:0,
                hoverIndex:-1,
                activeIndex: 0, // 当前激活的条目索引
                items: [
                    {
                        icon: require('../../../assets/home/chpc_about_industry_03.png'),
                        text: '精准识别数据风险，筑牢业务决策基石',
                        content:'医药/器械企业依赖渠道数据（如DDI、流向、仓储）支撑运营决策，但数据误差可能导致市场需求计划偏差、返利不公及合规危机。康柏汉森通过专业核查方案，对数据准确性进行现场核查，识别篡改、漏报等风险点，并结合第三方数据分析与管理诊断，提供客观评价与优化建议，助力客户提升数据质量，降低潜在风险。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_04.png'),
                        text: '穿透复杂业务场景，提升投资有效性',
                        content:'渠道及合规核查面临“一企一况”的复杂性，传统方法易被表象迷惑，难以溯源问题本质。康柏汉森凭借医药、器械及大健康行业专项资深经验和优质核查团队，精准甄别业务实质问题，评估投资有效性。同时，紧跟国家政策变化，动态调整核查方法，帮助客户降低合规风险与法律责任，保障业务健康发展。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_05.png'),
                        text: '强化合规经营，降低市场与行政风险',
                        content:'医药、器械及大健康行业需严格符合国家政策法规，但区域监管差异与人员管理水平差异导致的隐患频发。康柏汉森依托全国10大运营中心及区域化团队，深入一线核查经销商或代理商的数据管理、仓储管理、市场营销、三方公司及cso活动合规性管理等高危环节，提供多种评估模型科学研判业务合规风险并提出整改方案，助力企业降本增效，降低市场与行政处罚性风险。',
                    },
                    {
                        icon: require('../../../assets/home/chpc_about_industry_06.png'),
                        text: '精准风控护航，提升企业管理水平及美誉度',
                        content:'飞检与审核体量大、细节繁杂，疏漏易引发费用错支、投诉升级等连锁负面评价；企业管理漏洞会导致资源分配不均、特权滥用等，从而影响业务公平性。康柏汉森采用“系统预警+专家复核”模式，提升风险挖掘的有效性与及时性。帮助企业提升管理公平和合作健康；优化管理品质，协助维护商誉。',
                    }
                ],
                constants: {}
            };
        },
        methods: {
            handleSelectIndex(index){
                this.activeIndex = index;
                this.selectedIndex = index;
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                this.activeIndex = index;
            },
            offhoverIndexFun(){
                //this.activeIndex = this.selectedIndex ;
                //this.hoverIndex = -1;
            },
        }
    };
</script>
<style scoped lang="css"  >
    .page_czj {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .block_54 {
        position: relative;
        width: 1468px;
        align-items: center;
        margin-bottom: 1px;
    }

    .group_70 {
        background-color: rgba(255, 255, 255, 1);
        width: 1200px;
        height: 600px;

    }

    .text-group_231 {
        width: 100%;
        height: 96px;
        margin: 50px 0 0 0;
        align-items: center;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
         display: flex;
         flex-direction: column;
     }

    .text_199 {
        width: 400px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_200 {
        width: 400px;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .group_108 {
        width: 1105px;
        height: 355px;
        margin: 39px 0 60px 43px;
    }

    .group_109 {
        width: 520px;
        height: 355px;
        gap: 28px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .section_33_hover {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 520px;
        height: 69px;
        margin: 0 0 0 1px;
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }
    .section_33_hover_first {
        background-color: rgba(0, 120, 126, 0.1);
        border-radius: 4px;
        width: 520px;
        height: 69px;
        margin: 0 0 0 1px; /* 去除上边距 */
        transition: all 0.3s;
        cursor: pointer;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_33 {
        border-radius: 4px;
        width: 510px;
        height: 69px;
        border: 1px solid rgba(232, 232, 232, 1);
        cursor: pointer;
        transition: all 0.3s; /* 添加过渡效果 */
    }

    .label_11 {
        width: 22px;
        height: 24px;
        margin: 20px 0 0 25px;
    }

    .text_201 {
        width: 382px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(0, 120, 126, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 19px 64px 0 27px;
    }
    .text_202 {
        width: 360px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin: 20px 77px 0 26px;
    }



    .group_73 {
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.15);
        background-color: rgba(255, 255, 255, 1);
        width: 548px;
        height: 351px;
    }

    .image_37 {
        width: 550px;
        height: 120px;
        margin-left: -1px;
    }

    .image-text_195 {
        width: 501px;
        height: 180px;
        margin: 20px 0 31px 12px;
    }

    .thumbnail_9 {
        width: 12px;
        height: 14px;
        margin-top: 8px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .text-group_147 {
        width: 478px;
        height: 180px;
        overflow-wrap: break-word;
        color: rgba(85, 85, 85, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 30px;
    }

</style>
